// Single source of truth for camera lifecycle statuses.
// Terminado: archived, still visible to the customer, not billed.
// Suspendida: hidden from the customer (churn / non-payment), not billed.
export const NON_ACTIVE_STATUSES = ['Terminado', 'Suspendida'];

export const isCamaraActiva = (camara) => !!camara && !NON_ACTIVE_STATUSES.includes(camara.status);

export const isCamaraVisibleParaCliente = (camara) => !!camara && camara.status !== 'Suspendida';
